import script from "./LinkDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./LinkDialog.vue?vue&type=script&lang=ts&setup=true"

import "./LinkDialog.vue?vue&type=style&index=0&id=7c1697d2&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c1697d2"]])

export default __exports__